// Add this function in your component or utility functions
export function askForNotificationPermission() {
  return Notification.requestPermission();
  // Notification.requestPermission().then((permission) => {
  //   console.log(permission);
  //   if (permission === "granted") {
  //     console.log("Notification permission granted.");
  //     // you might want to subscribe here or ensure subscription
  //   } else {
  //     console.error("Notification permission denied.");
  //   }
  // });
}

export function subscribeToPush() {
  return navigator.serviceWorker.ready.then((registration) => {
    const publicKey =
      "BL-YwgSh1CpVNzdZXywWCiVgu2R6NXTgBszHdOIt4im5fxN7NRgrs89pxcdfsTjbvs08cfLLbNEsSHaXgRczyuk"; // Replace with your VAPID public key
    const subscribeOptions = {
      userVisibleOnly: true,
      applicationServerKey: publicKey,
    };

    return registration.pushManager
      .subscribe(subscribeOptions)
      .then((pushSubscription) => {
        console.log(
          "Received PushSubscription:",
          JSON.stringify(pushSubscription)
        );
        return pushSubscription; // Return the subscription object
      })
      .catch((err) => {
        if (Notification.permission === "denied") {
          console.error("Permission for notifications was denied");
          throw new Error("Permission for notifications was denied"); // Throw to ensure the error is propagated
        } else {
          console.error("Failed to subscribe the user: ", err);
          throw err; // Rethrow the error to handle it in the calling function
        }
      });
  });
}

// In your push notification service file, e.g., src/services/PushNotifications.js

/**
 * Checks if the user is currently subscribed to push notifications.
 * @returns {Promise<boolean>} A promise that resolves with the subscription status.
 */
export function checkSubscription() {
  // Ensure that service workers and push messaging are supported
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    console.error("Push messaging is not supported.");
    return Promise.resolve(false);
  }

  // Check the current service worker registration for an active subscription
  return navigator.serviceWorker.ready
    .then((registration) => {
      return registration.pushManager.getSubscription();
    })
    .then((subscription) => {
      // console.log(subscription);
      return subscription !== null; // If there's a subscription, return true
    })
    .catch((error) => {
      console.error("Error checking subscription status:", error);
      return false;
    });
}
